interface Membership {
    title: string;
    price: number;
}

const crossgym1_memberships: Membership[] = [
    {
        title: 'Разове тренування',
        price: 100
    },
    {
        title: 'Безлімітний (1 місяць)',
        price: 599
    },
    {
        title: 'Безлімітний (3 місяці)',
        price: 1399
    },
    {
        title: 'Безлімітний (6 місяців)',
        price: 2199
    },
    {
        title: 'Безлімітний (1 рік)',
        price: 3499
    },
    {
        title: '8 занять (без терміну дії)',
        price: 499
    },
    {
        title: 'Безлімітний студент/школяр до 14:00',
        price: 399
    },
    {
        title: 'Фітнес (разове тренування)',
        price: 100
    },
    {
        title: 'Фітнес (12 занять)',
        price: 900
    },
    {
        title: 'Групове тренування з тренером',
        price: 100
    },
    {
        title: 'Групове тренування з тренером (12 тренувань)',
        price: 1100
    },
    {
        title: 'Тренування з тренером',
        price: 200
    },
    {
        title: 'Тренування з тренером (12 тренувань)',
        price: 2200
    },
    {
        title: 'Індивідуальне тренування з тренером',
        price: 300
    },
    {
        title: 'Індивідуальне тренування з тренером (12 тренувань)',
        price: 3300
    },
];

export default crossgym1_memberships;
